export const ESTIMATE_ONE = '0f8a9d99-f1b7-4ae1-906d-036a13fbf4bd';

export enum PartnerUrls {
  EstimateOne = 'https://app.estimateone.com/_external/connection/veriforce_chas'
}

export enum PartnerNames {
  EstimateOne = 'estimateone'
}

export const CallbackAllowList: string[] = ['estimateone.com'];

export const PartnerIdToUrlMap = new Map<string, PartnerUrls>([[ESTIMATE_ONE, PartnerUrls.EstimateOne]]);
